module.exports = __webpack_public_path__ + "img/22.bece9be6.jpg";